
import HTTP from "@/_helpers/http";
import { PROFILE__API } from "@/_helpers/urls";
import { PROFILE__MUTATIONS } from "../mutation-types";
import { PROFILE__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
  client: null,
  businessAmount: 0,
  documentInfo: {
    identityVerification: "",
    residenceVerification: "",
    identityVerificationDocuments: [],
    residenceVerificationDocuments: [],
  },
  businessAmountLoading: false
};

const getters = {};

const mutations = {
  [PROFILE__MUTATIONS.PROFILE](state, client) {
    state.client = client;
  },
  [PROFILE__MUTATIONS.IDENTITYVERIFICATION](state, payload) {
    state.documentInfo.identityVerification = payload;
  },
  [PROFILE__MUTATIONS.RESIDENCEVERIFICATION](state, payload) {
    state.documentInfo.residenceVerification = payload;
  },
  [PROFILE__MUTATIONS.IDENTITYVERIFICATIONDOCUMENTS](state, payload) {
    state.documentInfo.identityVerificationDocuments = payload;
  },
  [PROFILE__MUTATIONS.RESIDENCEVERIFICATIONDOCUMENTS](state, payload) {
    state.documentInfo.residenceVerificationDocuments = payload;
  },
  [PROFILE__MUTATIONS.BUSINESSAMOUNT](state, payload) {
    state.businessAmount = payload.totalDepositAmount;
  },

  SET_LOADING(state, data) {
    state.businessAmountLoading = data
  },
};

const actions = {
  async [PROFILE__ACTIONS.GETPROFILE]({ commit }, id) {
    try {
      const response = await HTTP().get(
        `${PROFILE__API.FETCHPROFILE}?id=${id}`
      );
      commit(PROFILE__MUTATIONS.PROFILE, response.data.user);
      commit(
        PROFILE__MUTATIONS.IDENTITYVERIFICATIONDOCUMENTS,
        response.data.identityDoc
      );
      commit(
        PROFILE__MUTATIONS.RESIDENCEVERIFICATIONDOCUMENTS,
        response.data.residenceDoc
      );
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  },

  async [PROFILE__ACTIONS.BUSINESSAMOUNT]({ commit }) {
    commit("SET_LOADING", true);

    try {
      const response = await HTTP().get(PROFILE__API.BUSINESSAMOUNT);
      commit(PROFILE__MUTATIONS.BUSINESSAMOUNT, response.data);
    } catch (error) {
      console.error("Error fetching amount:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },


  async [PROFILE__ACTIONS.UPLOADDOCUMENT]({ commit, dispatch }, data) {
    try {
      const response = await HTTP().post(
        PROFILE__API.UPLOADDOCUMENT,
        data
      );

      await dispatch(PROFILE__ACTIONS.GETPROFILE)
      toast.success(response.data.message);
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    }
  },

};

export default {
  namespaced: true,
  strict: true,
  state,
  getters,
  actions,
  mutations,
};
